import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrgContextState, StateName } from './org-context-state';

export const selectOrgContext = createFeatureSelector<OrgContextState>(StateName);

export const selectOrgName = createSelector(selectOrgContext, (state) => state.org_name);
